export default "__VITE_ASSET__3d1118ff__"